import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

export interface IIconProps {
  className?: string;
  name: string;
  size?: 'xs' | 'small' | 'normal' | 'xNormal' | 'large' | 'xLarge' | 'xxLarge' | 'xxxLarge';
  round?: boolean;
}

const Icon: FunctionComponent<React.PropsWithChildren<IIconProps>> = ({ className, name, size = 'large' }) => (
  <i className={`${className} material-icons ${size}`} role="img" aria-label={`icon ${name}`}>
    {name}
  </i>
);

const StyledIcon = styled(Icon)`
  font-family: 'Material Icons';
  font-style: normal;
  font-size: 24px;
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;

  /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;

  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;

  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;

  /* Support for IE. */
  font-feature-settings: 'liga';

  &.primary {
    color: ${(props) => props.theme.colours.primaryB1};
  }

  &.secondary {
    color: ${(props) => props.theme.colours.secondary};
  }

  &.copper {
    color: #CF7938;
  }
  
  &.white {
    color: white;
  }

  &.grey20 {
    color: ${(props) => props.theme.colours.grey20};
  }

  &.grey50 {
    color: ${(props) => props.theme.colours.grey50};
  }

  &.xs {
    font-size: 8px;
  }

  &.small {
    font-size: 12px;
  }

  &.normal {
    font-size: 16px;
  }

  &.xNormal {
    font-size: 20px;
  }

  &.large {
    font-size: 24px;
  }

  &.xLarge {
    font-size: 32px;
  }

  &.xxLarge {
    font-size: 40px;
  }

  &.xxxLarge {
    font-size: 48px;
  }

  &.round-transparent {
    background-color: transparent;
    border: 2px solid #0c5460;
    font-size: 16px;
  }

  &.blue-border {
    border-color: #0c5460;
  }

  ${(props) =>
    props.round && `
    border-radius: 50%;
    border: 2px solid ${props.theme.colours.grey20};
    background-color: ${props.theme.colours.mainBackgroundColor};
    width: 1.25em;
    height: 1.25em;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  `}

  `;

export default StyledIcon;
